/************************************
MODULE:         Responsible with string transformations
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {

    function hexToStr(inputHex) {
        if (!inputHex) {
            return '';
        }

        var result = '';

        for (var t = 0; t < inputHex.length; t += 2) {
            result += String.fromCharCode(parseInt(inputHex.substr(t, 2), 16));
        }

        return result;
    }

    return {
        hexToStr: hexToStr
    };
}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.stringutils.js
 ** module id = 62
 ** module chunks = 24
 **/